writers<template>
  <div>

    <md-card>

      <md-card-content>

        <p>
          タイトル、執筆者、URLを入力してください。「*(アスタリスク)」が付いている項目は必須項目です。
        </p>

        <!-- タイトル -->
        <md-input-container
          md-clearable
          v-show="!articleTitleError">
          <label>タイトル</label>
          <md-input
            required
            v-model="articleTitle"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="articleTitleError"
          class="md-input-invalid">
          <label>タイトル</label>
          <md-input
            required
            v-model="articleTitle"></md-input>
          <span
            class="md-error"
            v-model="articleTitleError">{{ articleTitleError }}</span>
        </md-input-container>

        <!-- 執筆者 -->
        <md-input-container
          md-clearable
          v-show="!writersNameError">
          <label>執筆者</label>
          <md-input
            required
            v-model="writersName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="writersNameError"
          class="md-input-invalid">
          <label>執筆者</label>
          <md-input
            required
            v-model="writersName"></md-input>
          <span
            class="md-error"
            v-model="writersNameError">{{ writersNameError }}</span>
        </md-input-container>

        <!-- URL -->
        <md-input-container
          md-clearable
          v-show="!urlError">
          <label>URL</label>
          <md-input
            required
            v-model="url"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="urlError"
          class="md-input-invalid">
          <label>URL</label>
          <md-input
            required
            v-model="url"></md-input>
          <span
            class="md-error"
            v-model="urlError">{{ urlError }}</span>
        </md-input-container>

        <md-input-container>
          <label>記事の概略</label>
          <md-textarea v-model="description"></md-textarea>
        </md-input-container>

      </md-card-content>

      <md-list>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox0"
            name="my-test0"
            md-value="SetDance"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              セットダンス
            </span>
          </div>
        </md-list-item>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox1"
            name="my-test0"
            md-value="SeanNos"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              シャンノース
            </span>
          </div>
        </md-list-item>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox2"
            name="my-test0"
            md-value="CeiliDance"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              ケーリーダンス
            </span>
          </div>
        </md-list-item>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox3"
            name="my-test0"
            md-value="OldStyleStepDance"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              オールドスタイル
            </span>
          </div>
        </md-list-item>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox4"
            name="my-test0"
            md-value="ModernStyleStepDance"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              モダンスタイル
            </span>
          </div>
        </md-list-item>
        <md-list-item
          class="md-double-line">
          <md-checkbox
            id="checkbox5"
            name="my-test0"
            md-value="Others"
            v-model="selectedGenres"
            class="md-primary"></md-checkbox>
          <div class="md-list-text-container">
            <span>
              その他
            </span>
          </div>
        </md-list-item>
      </md-list>
      <!-- <span
        class="md-error"
        v-model="genresError">{{ genresError }}</span> -->

      <md-button
        id="addEvent"
        class="md-raised md-primary"
        @click="setEvent('dialog5')">記事のリンクを追加する</md-button>

    </md-card>

    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-confirm>

    <form
      novalidate
      @submit.stop.prevent="openErrorConsole">
      <md-snackbar
        :md-position="'top center'"
        ref="snackbar"
        :md-duration="4000">
        <span>{{ errorMessage }}</span>
      </md-snackbar>
    </form>

  </div>
</template>

<script>
import db from '../db'

export default {
  name: 'article',
  data () {
    return {
      articleId: this.$route.params.articleId,
      articleTitle: '',
      writersName: '',
      selectedGenres: [],
      url: '',
      description: '',
      articleTitleError: '',
      writersNameError: '',
      errorMessage: '',
      event: {},
      timeError: false,
      confirm: {
        title: '以下の内容で記事へのリンクを追加します。よろしいですか？',
        contentHtml: 'content',
        ok: '追加する',
        cancel: 'キャンセル'
      }
    }
  },
  firebase: {
    allSets: db.ref('/articles')
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    },
    getCurrentMonth () {
      return new Date().getMonth()
    },
    getCurrentDate () {
      return new Date().getDate()
    }
  },
  methods: {
    setEvent (ref) {
      // <strong>anonymous</strong>
      let isError = false
      this.timeError = false
      this.errorMessage = ''

      if (this.articleTitle === '') {
        this.errorMessage += 'タイトルを入力してください。'
        this.articleTitleError = 'タイトルを入力してください。'
        isError = true
      } else {
        this.articleTitleError = ''
      }

      if (this.writersName === '') {
        this.errorMessage += '執筆者を入力してください。'
        this.writersNameError = '執筆者を入力してください。'
        isError = true
      } else {
        this.writersNameError = ''
      }

      if (this.url === '') {
        this.errorMessage += 'URLを入力してください。'
        this.urlError = 'URLを入力してください。'
        isError = true
      } else {
        this.urlError = ''
      }

      if (this.selectedGenres.length === 0) {
        this.errorMessage += 'ジャンルを一つ選んでください。'
        this.genresError = 'ジャンルを一つ選んでください。'
        isError = true
      } else {
        this.genresError = ''
      }

      if (isError) {
        this.$refs.snackbar.open()
        return
      } else {
        this.errorMessage = ''
      }

      this.confirm.contentHtml = 'タイトル：' + this.articleTitle + '<br />執筆者：' + this.writersName + '<br />記事のジャンル：' + this.selectedGenres + '<br />' + 'URL：' + this.url
      this.$refs[ref].open()
    },
    openDialog (ref) {
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
    },
    onClose (type) {
      if (type !== 'ok') { return }
      let self = this
      let newArticleRef = db.ref('/articles').push()

      newArticleRef.set({
        id: newArticleRef.key,
        title: this.articleTitle,
        writers: this.writersName,
        genre: this.selectedGenres[0],
        genres: this.selectedGenres,
        description: this.description,
        timestamp: new Date().getTime(),
        url: this.url
      }).then(function () {
        self.$router.push({ name: 'Home', params: { articleId: newArticleRef.key } })
      })
      // .catch(function (error) {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.field-group {
  display: -webkit-flex; /* Safari */
  display: flex;
}
.md-input-container {
  /*display: flex;*/
}

h1, h2 {
  font-weight: normal;
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

a {
  color: #42b983;
}

#addEvent {
  margin: 24px 16px;
}
</style>



// WEBPACK FOOTER //
// AddArticle.vue?7319173a